import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface AccountBadgeProps {
    number: number
    variant?: 'standard' | 'compact'
    style?: StyleProp<ViewStyle>
}

const AccountBadge: FC<AccountBadgeProps> = ({ number, variant = 'standard', style }) => {
    const { styles } = useStyles(stylesheet, { variant })

    return (
        <View style={[styles.container, style]}>
            <Typography.Description font="bold" size="small">
                #{number}
            </Typography.Description>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ColorEnum.YELLOW_400,
        variants: {
            variant: {
                compact: {
                    padding: 4,
                    borderRadius: 4,
                },
                standard: {
                    width: 40,
                    height: 40,
                    borderRadius: 8,
                },
            },
        },
    },
})

export default AccountBadge
